import {css} from 'lit';
import {smartphoneOnly, tablet} from '../../js/services/const';

export default css`
  ::selection {
    background: var(--brand);
    color: var(--brand-text);
  }

  :host {
    display: block;
  }

  label {
    font-weight: 700;
    color: var(--text-highVisibility);
  }

  .gender-selection-woman {
    margin-right: 3rem;
  }

  @media (min-width: ${tablet}px) {
    .gender-selection-woman {
      margin-right: 2rem;
    }
  }

  .mod-slider.result {
    overflow: hidden;
    margin: 2rem 0;
    padding: 2rem 0;
  }

  .mod-slider.result .left-box {
    float: left;
    width: 80%;
  }

  .mod-slider.result .current-value {
    float: right;
    width: 75%;
    height: 5rem;
    color: white;
    margin-bottom: 0;
    overflow: visible;
    transition: background-color 0.3s;
  }

  .mod-slider.result .current-value input.value-field {
    position: relative;
    top: -1.4rem;
    height: auto;
    border-radius: 0;
    border: 0;
    color: white;
    background: transparent;
    text-align: left;
    line-height: 2;
    font-size: 3.2rem;
    padding: 0.8rem 0 0.8rem 46%;
    box-shadow: none;
  }

  .mod-slider.result .label {
    width: 25%;
    margin-top: 1rem;
    color: var(--text-highVisibility);
  }

  .mod-slider.result .slider,
  .mod-slider.result .statement {
    float: right;
    width: 75%;
    margin-top: 1rem;
  }

  .mod-slider.result .statement {
    color: var(--text-lowVisibility);
    font-style: italic;
    font-size: 2rem;
    font-family: var(--font-family-sans-serif);
    text-align: center;
    cursor: pointer;
  }

  .mod-slider.result .statement:hover,
  .mod-slider.result .statement:hover .icon {
    color: black;
  }

  .mod-slider.result .statement .icon {
    top: 0.2rem;
    margin-left: 1rem;
    color: grey;
    font-size: 2rem;
  }

  .mod-slider.result .triangle {
    position: absolute;
    left: 0;
    bottom: -1rem;
  }

  .mod-slider.result .triangle polygon {
    transition: fill 0.3s;
    fill: transparent;
  }

  .mod-slider.result .text-result {
    position: relative;
    clear: both;
    padding: 0 2rem;
  }

  .mod-slider.result .text-result .explanation {
    font-size: 1.6rem;
    font-family: var(--font-family-sans-serif);
    transition: all 0.5s;
  }

  .mod-slider.result .text-result .explanation.ng-hide-remove,
  .mod-slider.result .text-result .explanation.ng-hide-add.ng-hide-add-active {
    max-height: 0;
    opacity: 0;
    display: block !important;
  }

  .mod-slider.result .text-result .explanation.ng-hide-add,
  .mod-slider.result
    .text-result
    .explanation.ng-hide-remove.ng-hide-remove-active {
    max-height: 200px;
    opacity: 1;
    display: block !important;
  }

  .table-box {
    overflow: auto;
    margin-bottom: 1rem;
  }

  /*slider less*/

  .mod-slider .label,
  .mod-slider .comment,
  .mod-slider .slider,
  .mod-slider .figure,
  .mod-slider .value-field {
    float: left;
    box-sizing: border-box;
    margin: 0;
    font-family: var(--font-family-sans-serif);
    font-size: 1.6rem;
  }

  .mod-slider .label,
  .mod-slider .comment {
    width: 20%;
    padding-top: 0.5rem;
  }

  .mod-slider .comment {
    font-size: 1.5rem;
    float: right;
  }

  .mod-slider .current-value {
    position: relative;
    width: 7.8rem;
    overflow: hidden;
    margin: 0 auto 1rem;
  }

  .mod-slider .current-value .tooltip-picker-wrapper {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-right: 20px;
  }

  .mod-slider .current-value .tooltip-picker-wrapper .tooltip-picker-innerwrap {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .mod-slider .current-value input.value-field {
    width: 100%;
    height: 3.2rem;
    text-align: center;
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    font-size: 2rem;
    line-height: 1;
  }

  .mod-slider .current-value input.value-field::-webkit-outer-spin-button,
  .mod-slider .current-value input.value-field::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  .mod-slider .label {
    padding-right: 1rem;
    text-align: right;
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    color: var(--text-highVisibility);
  }

  .mod-slider .slider {
    position: relative;
    width: 60%;
  }

  .mod-slider .comment {
    padding-left: 1rem;
    color: var(--text-lowVisibility);
    text-align: left;
  }

  .mod-slider::after,
  .mod-slider .explanation,
  .mod-slider .label {
    clear: both;
  }

  .mod-slider {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    margin: 0 auto 2.5rem;
    padding: 0 0.2rem;
  }

  /** slider control */
  /* Clear custom range styles */
  .slider input[type='range'] {
    position: relative;
    background-color: transparent;
    border: 0;
    appearance: none; /* Hides the slider so that custom slider can be made */
    width: 100%; /* Specific width is required for Firefox. */
    padding: 0 0.2rem;
    margin: 0;
    z-index: 1199;
  }

  .slider input[type='range']::-webkit-slider-thumb {
    appearance: none;
  }

  .slider input[type='range']::-moz-focus-outer {
    border: 0;
  }

  .slider input[type='range']::-ms-track {
    width: 100%;
    cursor: pointer;
    background: transparent; /* Hides the slider so custom styles can be added */
    border-color: transparent;
    color: transparent;
  }

  .slider input[type='range']::-webkit-slider-thumb {
    height: 2.4rem;
    width: 2.4rem;
    transition: all 0.1s ease-in-out;
    padding: 0.5rem;
    border: 1px solid var(--cp-grey-light-3);
    border-radius: calc(2.4rem / 2);
    cursor: pointer;
    background: #f6f6f6;
    /*margin-top: -1.2rem; You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
  }

  /* Firefox - double size for border radius */
  .slider input[type='range']::-moz-range-thumb {
    height: 1.2rem;
    width: 1.2rem;
    transition: all 0.1s ease-in-out;
    padding: 0.5rem;
    border: 1px solid var(--cp-grey-light-3);
    border-radius: calc(2.4rem / 2);
    cursor: pointer;
    background: #f6f6f6;
  }

  .slider input[type='range']::-webkit-slider-thumb:active,
  .slider input[type='range']::-moz-range-thumb:active {
    transform: scale(1.2);
  }

  .slider input[type='range']::-webkit-slider-thumb:hover,
  .slider input[type='range']::-moz-range-thumb:hover  {
    background-color: var(--body-bg);
  }

  .slider input[type='range']::-webkit-slider-runnable-track,
  .slider input[type='range']::-moz-range-track {
    position: relative;
    height: 0.2rem;
    width: 100%;
    background-color: transparent;
    z-index: 1201;
    cursor: pointer;
  }
  .result .slider input[type='range']::-webkit-slider-runnable-track,
  .result .slider input[type='range']::-moz-range-track {
    background: var(--bmi-slider-gradient) no-repeat;
    background-size: 100% 100%;
  }

  /* style the overlapping line of the range input */
  .slider .color-track {
    position: absolute;
    top: 1.9rem;
    left: 0.2rem;
    height: 0.2rem;
    width: 100%;
    background-color: black;
    z-index: 0;
  }

  .result .slider .color-track {
    background: var(--bmi-slider-gradient) no-repeat;
    background-size: 100% 100%;
  }

  .slider {
    display: block;
  }

  @media (max-width: ${smartphoneOnly}px) {
    .mod-slider.result {
      background: none;
    }

    .mod-slider.result .left-box {
      width: 100%;
    }

    .mod-slider.result .left-box .current-value {
      width: 100%;
      margin-bottom: 0;
      margin-top: 2rem;
    }

    .mod-slider.result .left-box .slider {
      width: 100%;
    }

    .mod-slider.result .left-box .label {
      width: 50%;
    }

    .mod-slider.result .left-box .statement {
      float: none;
      width: 100%;
    }

    .text-result {
      padding: 0;
    }

    .right-box.figure {
      display: none;
    }

    /** slider less */

    .mod-slider {
      margin-bottom: 2rem;
      background-color: transparent;
    }

    .mod-slider .label,
    .mod-slider .comment {
      position: absolute;
      left: 0;
      top: 0;
      width: auto;
      margin-top: 0.8rem;
      text-align: left;
    }

    .mod-slider .comment {
      right: 0;
      text-align: right;
    }

    .mod-slider .current-value {
      margin-top: 1.4rem;
    }

    .mod-slider .current-value input.value-field {
      height: 3.2rem;
    }

    .mod-slider .slider {
      width: 100%;
    }
  }

  @media (min-width: ${tablet}px) {
    .mod-slider.result .statement {
      font-size: 1.9rem;
    }
    .mod-slider.result .figure {
      width: 98px;
      height: 150px;
      margin-left: 1.4rem;
      margin-bottom: 1rem;
      background-repeat: no-repeat;
      background-image: var(--bmi-figure);
      background-size: auto 100%;
    }
  }
`;
